import React from 'react'
import {Box, Text, Button, toast, Flex} from '@chakra-ui/react'
import MyStokkeLayoutDefault from '../layouts/default'
import {BasketIcon} from '../../../components/icons'
import {FormattedMessage, useIntl} from 'react-intl'
import {HOME_HREF, HYBRID_HOME, API_ERROR_MESSAGE} from '../../../constants'
import useCustomer from '../../../commerce-api/hooks/useCustomer'
import useAsync from '../../../commerce-api/hooks/useAsync'
import {useEffect} from 'react'
import useEffectEvent from '../../../hooks/use-effect-event'
import HybridLink from '../../../components/hybrid-link'
import MyStokkeBackToStokke from '../partials/back-to-stokke'
import MyStokkeFooter from '../partials/footer'
import MyStokkeLayoutEmpty from '../layouts/empty'
import OrderTile from '../partials/order-tile'
import LoadingSpinner from '../../../components/loading-spinner'

const MyStokkeOrders = () => {
    const customer = useCustomer()
    const {formatMessage} = useIntl()

    const {
        execute: fetchOrders,
        data: ordersData,
        error: ordersError,
        loading: ordersLoading
    } = useAsync(() => customer.getCustomerOrders())

    useEffect(() => {
        fetchOrders()
    }, [fetchOrders])

    const onError = useEffectEvent(() => {
        toast({
            title: formatMessage(API_ERROR_MESSAGE),
            status: 'error'
        })
    })

    useEffect(() => {
        if (ordersError) {
            console.error('Error fetching customer orders', ordersError)
            onError()
        }
    }, [ordersError, onError])

    return ordersLoading ? (
        <Box textAlign="center">
            <LoadingSpinner />
        </Box>
    ) : !ordersError && ordersData && ordersData.data.length > 0 ? (
        <MyStokkeLayoutDefault>
            <Text textStyle="Regular Small" color="stokkeGray.accessibleText">
                <FormattedMessage
                    defaultMessage="{orderCount, plural, one {Total of # order} other {Total of # orders}}"
                    id="mystokke.orders.counter"
                    values={{orderCount: ordersData.data.length}}
                />
            </Text>
            <Flex direction="column" gap={8} mt={8} mb={8}>
                {ordersData.data.map((order) => {
                    return <OrderTile order={order} key={order.orderNo} />
                })}
            </Flex>
            <MyStokkeFooter>
                <MyStokkeBackToStokke />
            </MyStokkeFooter>
        </MyStokkeLayoutDefault>
    ) : (
        <MyStokkeLayoutEmpty
            icon={<BasketIcon />}
            mainLabel={formatMessage({
                defaultMessage: 'No orders so far.',
                id: 'mystokke.orders.empty.headline'
            })}
            secondaryLabel={formatMessage({
                defaultMessage: "When you order items, you'll see them here.",
                id: 'mystokke.orders.empty.text'
            })}
        >
            <MyStokkeFooter>
                <Button as={HybridLink} to={HOME_HREF} page={HYBRID_HOME}>
                    <FormattedMessage
                        id="mystokke.orders.empty.button"
                        defaultMessage="Explore our products"
                    />
                </Button>
                <MyStokkeBackToStokke />
            </MyStokkeFooter>
        </MyStokkeLayoutEmpty>
    )
}

export default MyStokkeOrders
